import React from "react";
import { Paginator } from 'primereact/paginator';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const rowsPerPage = 1; 
  const totalRecords = totalPages;

  const handlePageChange = (event) => {
    onPageChange(event.page + 1);
  };

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "5px",
    }}>
      <Paginator
        first={(currentPage - 1) * rowsPerPage}
        rows={rowsPerPage}
        totalRecords={totalRecords}
        onPageChange={handlePageChange}
        template="PrevPageLink CurrentPageReport NextPageLink"
        currentPageReportTemplate="{currentPage} of {totalPages}"
        style={{ 
          border: 'none',
          padding: '0.5rem',
        }}
        pt={{
          root: { style: { backgroundColor: 'transparent' } },
          pages: { style: { display: 'none' } }
        }}
      />
    </div>
  );
};

export default Pagination;